import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Image,
  Carousel,
  Nav,
  Card,
  Navbar,
} from "react-bootstrap";
import droneImage from "../../assets/image/png/blog_image2.png";
import galleryImage1 from "../../assets/image/png/TrainingInstitutes_image3.png"; // Example new image
import galleryImage2 from "../../assets/image/png/TrainingInstitutes_image3.png"; // Example new image
import galleryImage3 from "../../assets/image/png/TrainingInstitutes_image3.png"; // Example new image
import Aos from "aos";
import { Link } from "react-router-dom";

const ProductPage = () => {
  const [inView, setInView] = useState(false);

  // Handle visibility of the elements when they come into view
  const handleScroll = () => {
    const cards = document.querySelectorAll(".fade-up");
    const windowHeight = window.innerHeight;
    cards.forEach((card) => {
      const rect = card.getBoundingClientRect();
      if (rect.top <= windowHeight - 100 && rect.bottom >= 100) {
        card.classList.add("fade-up-visible");
      }
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Initial check for elements in view

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  useEffect(() => {
    // Optionally, add a simple delay effect on images
    const images = document.querySelectorAll(".gallery-image");
    images.forEach((image, index) => {
      image.style.animationDelay = `${index * 0.3}s`;
    });
  }, []);
  return (
    <>
      {/* <Header /> */}
      <div style={{ overflow: "hidden" }}>
        {/* Header Section */}
        <Row
          style={{
            paddingTop: "20px",
            paddingBottom: "20px",
            backgroundColor: "#f8f8f8",
            alignItems: "center",
          }}
        >
          <Col md={6}>
            <h1 style={{ fontSize: "36px", fontWeight: "bold", color: "#333" }}>
              Hawk Drone
            </h1>
          </Col>
          <Col md={6} style={{ textAlign: "right" }}>
            <Nav style={{ justifyContent: "flex-end" }}>
              <Nav.Link
                href="#overview"
                style={{ fontSize: "16px", color: "#333" }}
              >
                Overview
              </Nav.Link>
              <Nav.Link
                href="#specs"
                style={{ fontSize: "16px", color: "#333" }}
              >
                Specs
              </Nav.Link>
              <Nav.Link
                href="#gallery"
                style={{ fontSize: "16px", color: "#333" }}
              >
                Gallery
              </Nav.Link>
              <Nav.Link
                href="#Features"
                style={{ fontSize: "16px", color: "#333" }}
              >
                Features
              </Nav.Link>
            </Nav>
          </Col>
        </Row>

        {/* Hero Section */}
        <Row
          style={{
            padding: "60px 0",
            backgroundColor: "#ffffff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center", // Centers the content horizontally
            position: "relative", // To make sure the text stays on top of the image
            height: "80vh", // Takes full height of the screen
            backgroundImage: `url(${droneImage})`,
            backgroundSize: "cover", // Ensures the image covers the section
            backgroundPosition: "center", // Centers the image
          }}
        >
          <Col
            md={6}
            style={{ textAlign: "center", zIndex: 2, position: "relative" }}
          >
            {/* Text Content */}
            <h1
              style={{
                fontSize: "40px",
                fontWeight: "bold",
                color: "#ffffff",
                marginBottom: "20px",
              }}
            >
              Hawk Drone with 4K HDR Camera
            </h1>
            <p
              style={{
                fontSize: "18px",
                color: "#ffffff",
                marginBottom: "20px",
              }}
            >
              Capture breathtaking visuals with unparalleled performance
            </p>
            <h3
              style={{
                fontSize: "32px",
                fontWeight: "bold",
                color: "#E60000",
                marginBottom: "20px",
              }}
            >
              ₹17,999{" "}
              <span
                style={{
                  textDecoration: "line-through",
                  color: "#aaa",
                  fontSize: "24px",
                }}
              >
                ₹24,999
              </span>
            </h3>
            <Button
              variant="primary"
              as={Link} // Use `as` prop to treat the Button as a Link
              to="/product-detail/674aaa2326333db736fffbf7" // Set the target URL here
              size="lg"
              style={{
                backgroundColor: "#E60000",
                borderColor: "#E60000",
                padding: "15px 30px",
                fontSize: "18px",
              }}
            >
              Buy Now
            </Button>
          </Col>
        </Row>
        <div style={{ padding: "60px 0", backgroundColor: "white" }}>
          <h2
            style={{
              fontSize: "32px",
              fontWeight: "bold",
              color: "black",
              textAlign: "center",
              marginBottom: "40px",
            }}
          >
            Key Features
          </h2>

          <Row id="Features" style={{ justifyContent: "center" }}>
            {/* Card 1 */}
            <Col md={4} sm={6} xs={12} style={{ padding: "20px" }}>
              <Card
                style={{
                  border: "none",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  transition: "transform 0.3s ease",
                }}
                className="feature-card"
              >
                <div
                  style={{
                    width: "100%",
                    height: "200px",
                    overflow: "hidden",
                    borderRadius: "8px 8px 0 0",
                  }}
                >
                  <img
                    src={droneImage} // Use your image here
                    alt="Feature 1"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover", // Ensures the image fits properly
                    }}
                  />
                </div>
                <Card.Body style={{ textAlign: "center", padding: "20px" }}>
                  <Card.Title
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      color: "#333",
                      marginBottom: "10px",
                    }}
                  >
                    Stunning 4K HDR Camera
                  </Card.Title>
                  <Card.Text style={{ fontSize: "14px", color: "#555" }}>
                    Capture every detail with incredible clarity and precision.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            {/* Card 2 */}
            <Col md={4} sm={6} xs={12} style={{ padding: "20px" }}>
              <Card
                style={{
                  border: "none",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  transition: "transform 0.3s ease",
                }}
                className="feature-card"
              >
                <div
                  style={{
                    width: "100%",
                    height: "200px",
                    overflow: "hidden",
                    borderRadius: "8px 8px 0 0",
                  }}
                >
                  <img
                    src={droneImage} // Use your image here
                    alt="Feature 2"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover", // Ensures the image fits properly
                    }}
                  />
                </div>
                <Card.Body style={{ textAlign: "center", padding: "20px" }}>
                  <Card.Title
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      color: "#333",
                      marginBottom: "10px",
                    }}
                  >
                    CMOS Sensor for Better Shots
                  </Card.Title>
                  <Card.Text style={{ fontSize: "14px", color: "#555" }}>
                    Enhanced low-light and color accuracy for professional
                    results.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            {/* Card 3 */}
            <Col md={4} sm={6} xs={12} style={{ padding: "20px" }}>
              <Card
                style={{
                  border: "none",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  transition: "transform 0.3s ease",
                }}
                className="feature-card"
              >
                <div
                  style={{
                    width: "100%",
                    height: "200px",
                    overflow: "hidden",
                    borderRadius: "8px 8px 0 0",
                  }}
                >
                  <img
                    src={droneImage} // Use your image here
                    alt="Feature 3"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover", // Ensures the image fits properly
                    }}
                  />
                </div>
                <Card.Body style={{ textAlign: "center", padding: "20px" }}>
                  <Card.Title
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      color: "#333",
                      marginBottom: "10px",
                    }}
                  >
                    Compact & Lightweight Design
                  </Card.Title>
                  <Card.Text style={{ fontSize: "14px", color: "#555" }}>
                    Lightweight and portable, perfect for on-the-go adventures.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>

        {/* Specifications Section */}
        <Row id="specs" style={{ padding: "60px 0", backgroundColor: "white" }}>
          <Col>
            <h2
              style={{
                fontSize: "32px",
                fontWeight: "bold",
                color: "#333",
                textAlign: "center",
                marginBottom: "40px",
              }}
            >
              Specifications
            </h2>

            <Row style={{ justifyContent: "center" }}>
              <Col md={4} className="spec-card fade-in">
                <div className="spec-card-content">
                  <img
                    src="https://img.icons8.com/ios/50/000000/drone.png" // Example icon for Drone
                    alt="Drone Icon"
                    className="spec-icon"
                  />
                  <h4>Brand</h4>
                  <p>Drone Planet</p>
                </div>
              </Col>

              <Col md={4} className="spec-card fade-in">
                <div className="spec-card-content">
                  <img
                    src="https://img.icons8.com/ios/50/000000/camera.png" // Example icon for Camera
                    alt="Camera Icon"
                    className="spec-icon"
                  />
                  <h4>Camera</h4>
                  <p>4K HDR with CMOS sensor</p>
                </div>
              </Col>

              <Col md={4} className="spec-card fade-in">
                <div className="spec-card-content">
                  <img
                    src="https://img.icons8.com/ios/50/000000/battery.png" // Example icon for Battery
                    alt="Battery Icon"
                    className="spec-icon"
                  />
                  <h4>Battery</h4>
                  <p>2500mAh, long-lasting battery</p>
                </div>
              </Col>

              <Col md={4} className="spec-card fade-in">
                <div className="spec-card-content">
                  <img
                    src="https://img.icons8.com/ios/50/000000/airplane-take-off.png"
                    alt="Altitude Icon"
                    className="spec-icon"
                  />

                  <h4>Max Altitude</h4>
                  <p>393 feet</p>
                </div>
              </Col>

              <Col md={4} className="spec-card fade-in">
                <div className="spec-card-content">
                  <img
                    src="https://img.icons8.com/ios/50/000000/weight.png" // Example icon for Weight
                    alt="Weight Icon"
                    className="spec-icon"
                  />
                  <h4>Weight</h4>
                  <p>201 grams</p>
                </div>
              </Col>

              <Col md={4} className="spec-card fade-in">
                <div className="spec-card-content">
                  <img
                    src="https://img.icons8.com/ios/50/000000/time.png" // Example icon for Flight Time
                    alt="Flight Time Icon"
                    className="spec-icon"
                  />
                  <h4>Flight Time</h4>
                  <p>10-15 minutes</p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>

        {/* Image Carousel (Product Gallery) */}
        <Row
          id="gallery"
          style={{ padding: "60px 0", backgroundColor: "#ffffff" }}
        >
          <Col>
            <h2
              style={{
                fontSize: "30px",
                fontWeight: "bold",
                color: "#333",
                textAlign: "center",
                marginBottom: "40px",
                animation: "fadeIn 1s ease-in-out",
              }}
            >
              Gallery
            </h2>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "20px",
              }}
            >
              <div>
                <img
                  className="gallery-image"
                  src={galleryImage1}
                  alt="Drone Image 1"
                  style={{
                    width: "100%",
                    maxHeight: "500px",
                    objectFit: "cover",
                    opacity: 0,
                    animation: "fadeIn 1s forwards",
                  }}
                />
              </div>
              <div>
                <img
                  className="gallery-image"
                  src={galleryImage2}
                  alt="Drone Image 2"
                  style={{
                    width: "100%",
                    maxHeight: "500px",
                    objectFit: "cover",
                    opacity: 0,
                    animation: "fadeIn 1s forwards",
                  }}
                />
              </div>
              <div>
                <img
                  className="gallery-image"
                  src={galleryImage3}
                  alt="Drone Image 3"
                  style={{
                    width: "100%",
                    maxHeight: "500px",
                    objectFit: "cover",
                    opacity: 0,
                    animation: "fadeIn 1s forwards",
                  }}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ProductPage;
